import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { RippleModule } from 'primeng/ripple';
import { ClientOmnisearchComponent } from './client-omnisearch.component';
import { StyleClassModule } from 'primeng/styleclass';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { TranslateModule } from '@ngx-translate/core';
import { BookAppointmentComponent } from '../schedule/appointment/book-appointment/book-appointment.component';
import { ScrollerModule } from 'primeng/scroller';
import { ClientSearchSidebarComponent } from './client-search-sidebar.component';
import { ScrollerModule as VirtualScrollerModule } from 'primeng/scroller';
import { DialogModule } from 'primeng/dialog';
import { CalendarComponent } from '../calendar/calendar.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DrawerModule,
    AvatarModule,
    ScrollPanelModule,
    CheckboxModule,
    TagModule,
    RippleModule,
    StyleClassModule,
    ShortNamePipe,
    TranslateModule,
    ScrollerModule,
    VirtualScrollerModule,
    BookAppointmentComponent,
    ClientSearchSidebarComponent,
    DialogModule,
    CalendarComponent,
    ProgressSpinnerModule,
    ClientOmnisearchComponent
  ],
  exports: [
    ClientOmnisearchComponent
  ]
})
export class ClientOmnisearchModule { } 